module.exports = __webpack_public_path__ + "static/media/MV.63b354b5.ico";